// extracted by mini-css-extract-plugin
export var dataCell = "_o5-2";
export var dataRow = "_o5-0";
export var headerRow = "_o5-1";